import { createActionGroup, emptyProps, props } from '@ngrx/store';
import { PermissionModels } from '@share-models';

export const PermissionsActions = createActionGroup({
  source: 'PERMISSIONS',
  events: {
    'Reset to Initial state': emptyProps,
    'Get User Permissions': emptyProps,
    'Get User Permissions Success': props<{
      permissions: PermissionModels.Permissions[];
      entityIds: string[];
    }>(),
    'Get User Permissions Fail': emptyProps,
  },
});
